export default __webpack_public_path__ + "static/media/EditorialNew-Regular.210d8558.otf";